module.exports = __webpack_public_path__ + "img/magento-custom-development@2x.4df3a9b3.webp";